import classNames from "classnames";
import { useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { EMAIL_HUB_STATUS_QUERY_KEY } from "@circle-react/hooks/useGetEmailHubStatus";
import { useUpgradePlanModal } from "@circle-react-shared/UpgradePlan";
import { UPGRADE_FLOW_SOURCES } from "@circle-react-shared/UpgradePlan/constants";
import { Button } from "@circle-react-shared/uikit/Button";
import { localeRoot } from "./constants";

interface CallToActionProp {
  modal?: boolean;
}

export const CallToAction = ({ modal }: CallToActionProp) => {
  const upgradePlanModal = useUpgradePlanModal();
  const { refetchCurrentPlan } = useCurrentPlanApi();
  const queryClient = useQueryClient();

  const onChangePlanSuccess = async () => {
    await queryClient.refetchQueries([EMAIL_HUB_STATUS_QUERY_KEY]);
    await refetchCurrentPlan();
  };

  const onClick = async () => {
    await upgradePlanModal.show({
      subheading: t(
        "pricing_plans.upgrade_modal.subheadings.email_hub_landing",
      ),
      isEmailHubRequired: true,
      onSuccess: onChangePlanSuccess,
      successButtonLabel: t(
        "pricing_plans.upgrade_modal.actions.back_to_community",
      ),
      showPlanDetails: true,
      source: UPGRADE_FLOW_SOURCES.EMAIL_HUB_LANDING_PAGE,
    });
  };

  return (
    <div
      className={classNames({
        "pb-8": !!modal,
      })}
    >
      <Button variant="circle" onClick={onClick} extraLarge>
        {t([localeRoot, "cta"])}
      </Button>
    </div>
  );
};
